export default "__VITE_ASSET__BcmH4lXD__"